









import store from '@/store';

export default
  name: 'Pankuzu'

  components: {
  }

  props:
    label:
      type: Array
      default: () => ([])

  data: () ->
    pankuzu: []

  mounted: () ->
    @pankuzu = @$route.meta.pankuzu
